import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaLock, FaEnvelope, FaEye, FaEyeSlash } from "react-icons/fa";
import "../Styles/AdminLogin.css";
import { BASE_URL } from "../config";
export default function ForgotPassword() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const res = await fetch(
        `${BASE_URL}forgotPass.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            password: newPassword,
          }),
        }
      );

      const data = await res.json();

      if (data.status === "success") {
        alert("Password updated successfully. Please login.");

        navigate("/lifetimeMyAdmin");
      } else {
        alert(data.message || "Email not found.");
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login-card">

        {/* Header */}
        <div className="admin-login-header">
          <div className="admin-login-icon">
            <FaLock />
          </div>

          <h2>Forgot Password</h2>

          <p>Enter your email and create a new password</p>
        </div>

        <form onSubmit={handleResetPassword}>

          {/* Email */}
          <div className="admin-input-group">
            <label>Email Address</label>

            <div className="admin-input-wrapper">
              <FaEnvelope className="admin-input-icon" />

              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          {/* New Password */}
          <div className="admin-input-group">
            <label>New Password</label>

            <div className="admin-input-wrapper">
              <FaLock className="admin-input-icon" />

              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                minLength={6}
                required
              />

              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          {/* Reset Button */}
          <button
            type="submit"
            className="admin-login-button"
            disabled={loading}
          >
            {loading ? "Updating..." : "Update Password"}
          </button>
  <div className="admin-login-options1">
            <button
              type="button"
              className="forgot-password"
              onClick={() => navigate("/lifetimeMyAdmin")}
            >
              Back to Login
            </button>
          </div>

          {/* Back to Login */}
        
        </form>

        <div className="admin-login-footer">
          <span>© {new Date().getFullYear()} Lifetime Infotech</span>
        </div>

      </div>
    </div>
  );
}